import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import Cloudinary from 'utils/Cloudinary';

const MOBILE_THUMBNAIL_SIZE = 54;
const DESKTOP_THUMBNAIL_SIZE = 58;

class ThumbnailButton extends React.Component {
  get image() {
    const { imageUrl } = this.props;
    const url = Cloudinary.generateRemoteImageUrl({
      remoteUrl: imageUrl,
      transformations: `q_auto,f_auto,w_120,b_rgb:f5f5f5`,
    });

    return `url(${url})`;
  }

  render() {
    const { ariaLabel, className, isSelected, onClick } = this.props;

    const ThumbnailButtonClass = classNames('ThumbnailButton', className, {
      'ThumbnailButton--active': isSelected,
    });

    return (
      <button className={ThumbnailButtonClass} onClick={onClick} aria-label={ariaLabel}>
        <div className="ThumbnailButton__thumbnail">
          <div className="ThumbnailButton__thumbnail-image" />
        </div>
        <style jsx>
          {`
            .ThumbnailButton {
              border-radius: ${Theme.get('border-radius-px')};
              border: 2px solid ${Theme.get('colors-white')};
              outline: 0;
              background-color: transparent;
              cursor: pointer;
              padding: 0;
              font: initial;
              appearance: none;
              display: flex;
              text-align: center;
            }

            .ThumbnailButton:hover,
            .ThumbnailButton:focus,
            .ThumbnailButton--active {
              transition: border-color ease-in-out ${Theme.get('transition-duration') / 2}ms;
            }

            .ThumbnailButton:hover,
            .ThumbnailButton:focus {
              border-color: ${Theme.get('colors-black-20')};
            }

            .ThumbnailButton--active,
            .ThumbnailButton--active:focus,
            .ThumbnailButton--active:hover {
              border-color: ${Theme.get('colors-black-20')};
            }

            .ThumbnailButton.focused {
              outline: 2px solid ${Theme.get('colors-black')};
            }

            .ThumbnailButton__thumbnail {
              border: 2px solid ${Theme.get('colors-grey')};
              border-radius: ${Theme.get('border-radius-px')};
              display: block;
              background: ${Theme.get('colors-grey')};
              width: ${MOBILE_THUMBNAIL_SIZE}px;
              height: ${MOBILE_THUMBNAIL_SIZE}px;
            }
            @media ${mediumUp} {
              .ThumbnailButton__thumbnail {
                width: ${DESKTOP_THUMBNAIL_SIZE}px;
                height: ${DESKTOP_THUMBNAIL_SIZE}px;
              }
            }

            .ThumbnailButton__thumbnail-image {
              width: 100%;
              height: 100%;
              background: ${this.image};
              background-size: cover;
              background-position: center;
            }
          `}
        </style>
      </button>
    );
  }
}

ThumbnailButton.propTypes = {
  imageUrl: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  isSelected: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

ThumbnailButton.defaultProps = {
  onClick: () => {},
  imageUrl: '',
  className: '',
  isSelected: false,
  ariaLabel: '',
};

export default ThumbnailButton;
